import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Spacing from '../layout/Spacing';
import Text from '../chrome/Text';
import Image from '../chrome/Image';
import CircleBullet from '../ui/CircleBullet';

const colBaseStyles = () => css``;

const Col = styled('div')(colBaseStyles);

const baseStyles = () => css`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const Container = styled('div')(baseStyles);

const styledTitleBaseStyles = ({ theme }) => css`
  color: ${theme.component.howToTitleColor};
  line-height: 20px;
`;

const StyledTitle = styled(Text)(styledTitleBaseStyles);

const imageContainerBaseStyles = () => css`
  display: flex;
  justify-content: center;
  max-width: 250px;
`;

const imageContainerPositionStyles = ({ theme, position }) =>
  position === 'left'
    ? css`
        margin-right: ${theme.spacings.giga};
        margin-left: ${theme.spacings.giga};
      `
    : css`
        margin-left: ${theme.spacings.giga};
        margin-right: ${theme.spacings.giga};
      `;

const imageContainerSizeStyles = ({ assetSize }) =>
  assetSize &&
  css`
    max-width: ${assetSize}px;
  `;

const ImageContainer = styled('div')(imageContainerBaseStyles, imageContainerPositionStyles, imageContainerSizeStyles);

const GuideStep = ({ variant, step, title, text, ...props }) => {
  const guideImage = ({ position, assetUrl, assetAlt, assetSize }) => (
    <Col>
      <ImageContainer position={position} assetSize={assetSize}>
        <Image src={assetUrl} alt={assetAlt} />
      </ImageContainer>
    </Col>
  );

  return (
    <Container>
      {variant === 'left' && guideImage({ position: variant, ...props })}
      {step && (
        <Col>
          <CircleBullet text={step} />
        </Col>
      )}
      <Col>
        <Spacing sides>
          <StyledTitle as='h3' size='tera' bold>
            {title}
          </StyledTitle>
          {text && (
            <Text size='giga' noMargin>
              {text}
            </Text>
          )}
        </Spacing>
      </Col>
      {variant === 'right' && guideImage({ position: variant, ...props })}
    </Container>
  );
};

GuideStep.propTypes = {
  step: PropTypes.number,
  title: PropTypes.string,
  text: PropTypes.string,
  assetUrl: PropTypes.string,
  assetAlt: PropTypes.string,
  variant: PropTypes.string,
};

GuideStep.defaultProps = {
  title: 'This is a title.',
  assetUrl: 'https://via.placeholder.com/100x120',
  variant: 'right',
};

export default GuideStep;
